<template>

    <popup-modal
        :title="$t('applications.competence_import_title')"
        :description="$t('applications.competence_import_description')"
        @close="$emit('close')"
        position="center"
    >
        <div class="w-480">
            <loading v-if="fetchingCompetences"></loading>
            <div v-else>

                <div class="flex items-end">
                    <select-dropdown
                        prefixIcon="license"
                        v-model="selectedCompetence"
                        :options="availableCompetences"
                        :auto-translate="false"
                        class="mr-16 flex-grow"
                    >
                        {{ $t('applications.add_single_competence') }}
                    </select-dropdown>
                    <simple-button
                        display="success"
                        :disabled="selectedCompetence == 0 || addingTaggedCompetences"
                        class="flex-none"
                        :loading="addingCompetence"
                        @click="addCompetence"
                    >{{ $t('general.add') }}</simple-button>
                </div>

                <div class="text-center text-primary-40 text-big font-semibold pt-32 mb-32">{{ $t('general.or') }}</div>

                <div class="flex items-end">
                    <select-dropdown
                        prefixIcon="sell"
                        v-model="selectedTag"
                        :options="availableTags"
                        :auto-translate="false"
                        class="mr-16 flex-grow"
                    >
                        {{ $t('applications.add_tagged_competences') }}
                    </select-dropdown>
                    <simple-button
                        display="success"
                        :disabled="selectedTag == 0 || addingCompetence"
                        class="flex-none"
                        :loading="addingTaggedCompetences"
                        @click="addTaggedCompetences"
                    >{{ $t('general.add') }}</simple-button>
                </div>

            </div>
        </div>
    </popup-modal>

</template>

<script>
import PopupModal from './PopupModal.vue';
import * as competences from '../../services/CompetenceService';
import * as tags from '../../services/TagService';
import { normalizeJson } from '../../../shared/helpers';
import Competence from '../../models/Competence';
import Job from '../../models/Job';
import JobCompetence from '../../models/JobCompetence';
import Loading from './Loading.vue';
import Tag from '../../models/Tag';
import SelectDropdown from '../forms/SelectDropdown.vue';
import SimpleButton from './SimpleButton.vue';
import { mapState } from 'pinia';
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';

export default {
    components: {
        'popup-modal': PopupModal,
        'loading': Loading,
        'select-dropdown': SelectDropdown,
        'simple-button': SimpleButton,
    },
    props: {
        job: {
            required: true,
            type: Job,
        },
        importedCompetences: {
            required: true,
            type: Array,
        }
    },
    data: function () {
        return {
            fetchingCompetences: true,
            selectedTag: '0',
            selectedCompetence: '0',
            addingTaggedCompetences: false,
            addingCompetence: false,
        }
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
        competenceTags () {
            return useRepo(Tag)
                .with('competences')
                .has('competences')
                .get();
        },
        availableTags () {

            return [
                { value: 0, label: this.$t('general.choose_subject', {subject: this.$t('applications.a_tag')}) },
                ...this.competenceTags.map(tag => ({ value: tag.id, label: tag.title })),
            ]
        },
        competences () {

            let currentIds = this.importedCompetences.map(comp => comp.competence.id);

            return useRepo(Competence)
                .where(competence => {
                    return !currentIds.includes(competence.id)})
                .get();
        },
        availableCompetences () {

            return [
                { value: 0, label: this.$t('general.choose_subject', {subject: this.$t('applications.a_competence')})},
                ...this.competences.map(competence => ({ value: competence.id, label: competence.title[this.locale]}))
            ]
        }
    },
    methods: {
        addTaggedCompetences () {

            this.addingTaggedCompetences = true;

            let tag = this.competenceTags.find(({id}) => id == this.selectedTag);

            competences.storeForJobBulk(this.job.id, {
                data: tag.competences.map(({id}) => ({ id, pivot: { weight: 'default' } }))
            }).then(result => {
                return useRepo(JobCompetence).save(normalizeJson(result));
            }).then(inserts => {
                this.$emit('close');
            })
        },
        addCompetence () {

            this.addingCompetence = true;

            competences.storeForJob(this.job.id, { data: {
                id: this.selectedCompetence,
                pivot: {
                    weight: 'default',
                }
            }}).then(result => {
                return useRepo(JobCompetence).save(normalizeJson(result));
            }).then(inserts => {
                this.$emit('close');
            });
        }
    },
    mounted () {
        competences.index().then(result => {
            return useRepo(Competence).save(normalizeJson(result.data));
        }).then(inserts => {
            this.fetchingCompetences = false;
        });
    }
}
</script>
